import Image from 'next/image';
import type { ReactNode } from 'react';

import { formattedPrice } from '@/ui-kit/price';

import { ProductModalVariantProduct } from '../../types';

import { styles } from './ProductTile.styles';

export interface ProductTileProps {
  product: ProductModalVariantProduct;
  selectedVariantId?: string | null;
  quantitySlot?: ReactNode;
}

export function ProductTile({
  product,
  selectedVariantId = null,
  quantitySlot
}: ProductTileProps) {
  const slots = styles();

  const selectedOffer = selectedVariantId
    ? product.productOffers.find((offer) => offer.uuid === selectedVariantId)
    : undefined;

  const price = selectedOffer?.price ?? product.price;

  return (
    <div className={slots.base()}>
      <div className={slots.imageWrapper()}>
        <Image
          className={slots.image()}
          src={product.imageUrl}
          alt={product.name}
          fill
        />
      </div>
      <div className={slots.content()}>
        <div className={slots.title()}>{product.name}</div>
        {price > 0 && (
          <div className={slots.price()}>
            <div className={slots.priceValue()}>{formattedPrice(price)}</div>
            {product.oldPrice && (
              <div className={slots.oldPrice()}>{formattedPrice(product.oldPrice)}</div>
            )}
            {product.discountPercent > 0 && (
              <div className={slots.discount()}>-{product.discountPercent}%</div>
            )}
          </div>
        )}
        {quantitySlot}
      </div>
    </div>
  );
}
